import styled from 'styled-components';

export const LineChartContainer = styled.div`
  height: 100%;
`;
